<template>
  <div class="">
    <div v-if="rates">
        <div v-for="(rate, index ) in rates" :key="index">
          <div>


            <div class="price-row" v-if="service.charge_by == 'one_off' " style="text-align: left">
              <div class="row">
                <div class="col-xs-8" >
                  {{ rate.rate_title  }}
                </div>
                <div class="col-xs-4" style="text-align: right">
                  {{ currency.currency_symbol }}{{ rate.cost }}
                </div>
              </div>
            </div>
            <div>


              <div v-if="service.charge_by == 'time' || service.charge_by == 'unit' ">
              </div>


              <div class="price-row" v-if="rate.min_range && rate.max_range ">
                <div class="row">
                  <div class="col-xs-5">
                    {{ rate.min_range }}-{{ rate.max_range }}{{ unit }}
                  </div>
                  <div class="col-xs-7">{{ currency.currency_symbol }}{{ rate.cost }}/{{ unit }} </div>
                </div>
              </div>

            </div>
          </div>
        </div>
    </div>



  </div>
</template>


<script>


export default {
  name: "ServiceViewRightMenuPriceList_rates",
  props: [
    'service',
    'currency',
    'rates',
    'unit',
  ],
  data() {
    return {

    }
  },
  methods:{

  },
  computed: {

  },
  mounted(){

  }
}
</script>

